import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import config from './modules/config';
import exam from './modules/exam';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    config,
    exam
  },
  strict: process.env.NODE_ENV !== 'production'
});
